import React from 'react';
import LegalDocumentView from '../components/Legal/LegalDocumentView';

const TermsOfService = () => (
  <LegalDocumentView type="USER_TERMS" title="Általános Szerződési Feltételek (Felhasználók)" />
);

export default TermsOfService;
